import type { DeviceTag, ViewTemplate } from '@nfc-api/tag';
import type { MeasurementValue } from '@nfc-api/device';

export type SensorViewValues = {
  name: string;
  template: ViewTemplate;
  updated: string;
  address: string;
  serial: string;
  batch: string;
  deviceId: string;
  battery: number;
  batteryUnit: string,
  values: Array<SensorValue>,
}

export type SensorValue = {
  value: string | number | undefined;
  unit: string;
  type: string;
  name?: string;
  channel?: number;
  index?: number;
}

export const defaultSensorViewValues: SensorViewValues = {
  name: '',
  address: '',
  updated: '',
  battery: 0,
  serial: '',
  batteryUnit: '',
  batch: '',
  deviceId: '',
  template: 'default',
  values: [],
};

export const buildSensorData = (tag: DeviceTag): SensorViewValues => {
  const payload = tag.payload;

  if (!payload?.sensor) return defaultSensorViewValues;

  const sensor = payload.sensor;

  const battery = sensor.values.find(v => v.type === 'battery');
  const values : SensorValue[] = sensor
    ? sensor.values
      .filter(v => v.type !== 'battery')
      .map((m: MeasurementValue) => (
        {
          value: m.value,
          unit: m.unit,
          type: m.type,
          name: m.name,
          index: m.index
        }
      ))
    : [];

  return {
    name: sensor.name,
    address: sensor.locationDescription,
    updated: new Date(sensor.timeStamp as string)?.toLocaleString(),
    battery: battery?.value ?? 0,
    batteryUnit: battery?.unit ?? '',
    serial: sensor.serial ?? '12E1234B54321',
    deviceId: sensor.id,
    batch: 'X2382320',
    template: payload.template,
    values,
  };
};
